import { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

/** useSmartSuggestions — fetches last N line-items for a client (invoice) or
 * vendor (PO / purchase). Debounced by 400ms.
 *
 * Usage in an invoice sheet:
 *   const { suggestions, applying, apply } = useSmartSuggestions("invoice", client);
 */
export function useSmartSuggestions(kind, key) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!key || key.length < 2) { setSuggestions([]); return; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const url = kind === "invoice"
          ? `/suggestions/invoice-items?client=${encodeURIComponent(key)}`
          : `/suggestions/po-items?vendor=${encodeURIComponent(key)}`;
        const { data } = await api.get(url);
        setSuggestions(data?.suggestions || []);
      } catch { setSuggestions([]); }
      finally { setLoading(false); }
    }, 400);
    return () => clearTimeout(t);
  }, [kind, key]);

  return { suggestions, loading };
}
